import { Component, Input, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DocumentViewerModalComponent } from '../document-viewer-modal/document-viewer-modal.component';
import { AttachmentBase } from 'src/sb-tools/typescript/models/attachment-base.model';
import { DOCUMENT_VIEWER_MODAL_ID } from 'src/sb-tools/typescript/constants/nested-modal-ids';
import { Dimensions } from '@sb-tools/typescript/models/dimensions';
import { DocumentWindowMessageType } from '@sb-document-viewer/enums/document-window-message-type';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';
import { NgClass, NgStyle, SlicePipe } from '@angular/common';

export declare type OrientationType = 'horizontal' | 'vertical';

@Component({
    selector: 'sb-grid-gallery',
    templateUrl: './grid-gallery.component.html',
    styleUrls: ['./grid-gallery.component.scss'],
    imports: [LoaderComponent, NgStyle, NgClass, SlicePipe],
})
export class GridGalleryComponent implements OnInit {
    @Input() attachment: AttachmentBase;
    @Input() isEnablePostMessageForWidget?: boolean = false;
    @Input() permalink: string;

    attachmentsCount: number;
    firstImageOrientation: OrientationType;
    isDisplayFiveImages: boolean;
    isGalleryOfFourEqualImages: boolean;
    isGalleryOfTwoEqualImages: boolean;
    isLoaded: boolean;

    constructor(private bsModalService: BsModalService) {}

    ngOnInit(): void {
        this.attachmentsCount = this.attachment.attachments.length;

        const firstImageSize: Dimensions =
            this.attachment.attachments[0].sizeMetadata && this.attachment.attachments[0].sizeMetadata.dimensions;

        if (firstImageSize && firstImageSize.width && firstImageSize.height) {
            this.initGalleryView(firstImageSize);
        } else {
            this.loadImageSize(this.attachment.attachments[0].url);
        }
    }

    openInWindow(index: number): void {
        if (this.isEnablePostMessageForWidget) {
            window.parent.postMessage(
                {
                    messageType: DocumentWindowMessageType.openPreviewModal,
                    attachment: this.attachment,
                },
                '*',
            );
            return;
        }
        const initialState = {
            modalId: DOCUMENT_VIEWER_MODAL_ID,
            isImage: true,
            attachments: this.attachment.attachments,
            fileIndex: index,
            isFilePreviewInMessage: true,
            permalink: this.permalink,
        };

        this.bsModalService.show(DocumentViewerModalComponent, {
            initialState,
            class: 'modal-lg modal-document-viewer',
            id: DOCUMENT_VIEWER_MODAL_ID,
        });
    }

    private initGalleryView(firstImageSize: Dimensions): void {
        this.firstImageOrientation = firstImageSize.width > firstImageSize.height ? 'horizontal' : 'vertical';

        if (this.attachmentsCount === 4) {
            this.isGalleryOfFourEqualImages = firstImageSize.width === firstImageSize.height;
            this.isLoaded = true;
            return;
        }

        if (this.attachmentsCount === 2) {
            const secondImageSize =
                this.attachment.attachments[1].sizeMetadata && this.attachment.attachments[1].sizeMetadata.dimensions;

            if (secondImageSize && secondImageSize.width && secondImageSize.height) {
                const secondImageOrientation =
                    secondImageSize.width > secondImageSize.height ? 'horizontal' : 'vertical';
                this.isGalleryOfTwoEqualImages = this.firstImageOrientation !== secondImageOrientation;

                this.isLoaded = true;
            } else {
                this.loadImageSize(this.attachment.attachments[1].url, true);
            }
        } else {
            this.isLoaded = true;
        }
    }

    private loadImageSize(url: string, isSecondImage?: boolean): void {
        const img = new Image();
        img.onload = () => {
            if (!isSecondImage) {
                const firstImageSize = {
                    width: img.width,
                    height: img.height,
                };
                this.initGalleryView(firstImageSize);
            } else {
                const secondImageSize = {
                    width: img.width,
                    height: img.height,
                };

                const secondImageOrientation =
                    secondImageSize.width > secondImageSize.height ? 'horizontal' : 'vertical';
                this.isGalleryOfTwoEqualImages = this.firstImageOrientation !== secondImageOrientation;

                this.isLoaded = true;
            }
        };
        img.src = url;
    }
}
